<template>

<div class="bar" v-is:selectable="isSelectable">

    <div class="bar-item" v-for="(item, index) in items" v-is:active="category === item.id" :key="index" v-on:click="onItemClick(item.id)">

        <div class="bar-item-fill" :style="{width: item.width}" />

        <div class="bar-item-name">{{ item.name }}</div>

        <div class="bar-item-value">{{ item.value | prettyNumber }}</div>

    </div>

</div>

</template>

<script>

export default {
	
    props: ['data', 'isSelectable', 'category'],

    computed: {

        items: function() {

            var items = []

            var max = this.$_.max(this.data, function(item) {

                return item.value

            }).value

            this.$_.each(this.data, function(item, key) {

                items.push({
                    id: key,
                    name: item.name,
                    value: item.value,
                    width: ((100 / max) * item.value).toString() + '%'
                })

            })

            return items

        }
        
    },

    methods: {

        onItemClick: function(value) {

            if (this.isSelectable) this.$emit('click', value)

        }

    }

}

</script>

<style scoped>

.bar {
    display: grid;
    grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 21px;
    padding-top: 20px;
}

.bar-item {
    height: 40px;
    background-color: #F9F9F9;
    border-radius: 4px;
    width: 100%;
}

.bar.is-selectable .bar-item:hover {
    background-color: #eee;
    cursor: pointer;
}

.bar-item-fill {
    height: 40px;
    background-color: #C4F1E8;
    border-radius: 4px;
}

.bar.is-selectable .bar-item:not(.is-active):hover .bar-item-fill {
    background-color: #b1dfd6;
}

.bar-item.is-active .bar-item-fill {
    background-color: #1AD598;
}

.bar-item-name {
    color: #050505;
    font-size: 14px;
    font-weight: 700;
    position: absolute;
    left: 20px;
    top: 0px;
    line-height: 40px;
}

.bar-item-value {
    color: #050505;
    font-size: 14px;
    font-weight: 700;
    position: absolute;
    right: 20px;
    top: 0px;
    line-height: 40px;
}

</style>
